/**
 * Retorna o numero passado por parametro com valor relativo se estivesse em
 * novos valores minimos e maximos. Faz a conta para que o valor dentro de
 * uma escala de valores seja convertido para outra escala de valores.
 * Por exemplo: o valor 5 de 0 até 10 retorna como o valor 50 de 0 até 100
 * @param oldValue Valor original que será convertido
 * @param oldMin Valor minimo do espaço de valor original
 * @param oldMax Valor máximo do espaço de valor original
 * @param newMin Valor minimo do novo espaço de valor
 * @param newMax Valor máximo do novo espaço de valor
 * @returns newValue Valor convertido para o novo espaço de valor
 */
const scale = (oldValue, oldMin, oldMax, newMin, newMax) => (
  (newMax - newMin) * (oldValue - oldMin) / (oldMax - oldMin) + newMin);

/**
* Retorna o menor valor de uma determinada precisão.
* Por exemplo: O menor valor para precisão 3 é 0,001
* @param precision Precisão em decimal que se quer obter o menor valor
* @returns Menor valor de uma determinada precisão decimal
*/
const minValueByPrecision = precision => 10 ** (-precision);

export default {
  minValueByPrecision,
  scale,
};
